export const parkingBookingUrl = 'https://parking.cvgairport.com/';
export const artOfContextMapUrl = 'https://maps.cvgairport.com/';
